import React from 'react'
import type { BoxProps } from '@chakra-ui/react'
import { forwardRef, Box } from '@chakra-ui/react'

interface OfferWrapperProps extends BoxProps {}

export const OfferWrapper = forwardRef<OfferWrapperProps, 'div'>(({ children, ...rest }, ref) => {
  return (
    <Box sx={{ borderRadius: 'md', boxShadow: 'card' }} ref={ref} {...rest}>
      {children}
    </Box>
  )
})
